'use strict';

angular.module('app.campaignOverview', [])
    .controller('campaignOverviewCtrl', ['$scope', '$rootScope', '$http' , '$modal', '$state', 'adminService', 'campaignOverviewService',
        function ($scope, $rootScope, $http, $modal, $state, adminService, campaignOverviewService){
            var me = this;
            me.currentPage = 1;
            me.pageSize = 25;
            me.accountId = 0;
             
            var loadData = function(){
                var params = {
                    accountId: me.accountId,
                    limit: me.pageSize,
                    pageNo: me.currentPage,
                }

                getCampaignOverviewList(params);
            };

            var getCampaignOverviewList = function(params){
                campaignOverviewService.getCampaignOverviewList(null, params, false)
                    .then(function(response) {
                        me.campaignList = response.data;
                        getTotalCampaignActivities(me.accountId);
                        for (var i=0; i<me.campaignList.length; i++) {
                            me.campaignList[i].lastTime = moment(me.campaignList[i].lastInteraction + 'Z').fromNow(); // 2017-11-20 15:58:00.0
                        }
                    }, function(response) {
                      me.campaignList = [];
                    });
            };

            var getTotalCampaignActivities = function(params){
                campaignOverviewService.getTotalCampaignActivities(null, params, false)
                    .then(function(response) {
                        me.totalRow = response.data.totalCampaignActivities;
                        paginate();
                    });
            };

            var getAllCompanies = function(params){
                campaignOverviewService.getAllCompanies(null, null, false)
                    .then(function(response) {
                        me.accountList = [];
                      angular.forEach(response.data, function(company) {
                        me.accountList.push({
                          id: company.id,
                          name: company.name,
                          ticked: false
                        });
                      });
                      me.accountList.unshift({id: 0, name: "Show All", ticked: true});

                    }, function(response) {
                      me.accountList = [];
                    });
            };

            var paginate = function(){
                me.totalPage = adminService.pagination(me.totalRow, me.pageSize);
            };

            //Traverse through pages
            var updatePage = function(currentPage){
                me.currentPage = currentPage;
                var params = {
                    accountId: me.accountId,
                    limit: me.pageSize,
                    pageNo: me.currentPage,
                };

                getCampaignOverviewList(params);
            };

            var onAccountSelected = function (item) {
                me.accountId = item.id;
                me.currentPage = 1; // set page 1
                $scope.currentPage = 1; // set page 1
                var params = {
                    accountId: me.accountId,
                    limit: me.pageSize,
                    pageNo: me.currentPage,
                };
                getCampaignOverviewList(params);
                getTotalCampaignActivities(me.accountId);
            };

            (function init() {
                loadData();
                getAllCompanies();
                me.updatePage = updatePage;
                me.onAccountSelected = onAccountSelected;

            })();
}])